import { combineReducers } from 'redux';

import {
    SupplierSpecialOffersDetailReducerState,
    supplierSpecialOffersDetailReducer,
} from '../supplier-special-offers-detail/store/supplier-special-offers-detail-reducer';
import {
    SupplierSpecialOffersListReducerState,
    supplierSpecialOffersListReducer,
} from '../supplier-special-offers-list/store/supplier-special-offers-list-reducer';

export interface SupplierSpecialOffersReducerState {
    list: SupplierSpecialOffersListReducerState;
    detail: SupplierSpecialOffersDetailReducerState;
}

export const supplierSpecialOffersReducer = combineReducers<SupplierSpecialOffersReducerState>({
    list: supplierSpecialOffersListReducer,
    detail: supplierSpecialOffersDetailReducer,
});
